import React from 'react';
import speechTable from '../../../assets/images/theraputic_screen/speech_table.jpg';
import GradientOutlineButton from '../../../components/atoms/GradientOutlineButton';
import GradientButton from '../../../components/atoms/GradientButton';
import { motion } from 'framer-motion';
import ModalitiesSection from './ModalitiesSection';
import { useMediaQuery } from 'react-responsive';

const SpeechTherapy = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  const TitleAndDescription = ({ title, description }) => {
    return (
      <div className="flex-1 flex flex-col gap-1">
        <h2
          className="text-[28px] sm:text-[34px] text-primary font-bold leading-tight"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <p
          className="text-secondary text-lg 2xl:text-2xl"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    );
  };

  const servicesData = [
    {
      name: 'Other Diagnoses',
      items: [
        'Cleft Lip and Palate',
        'Tongue-thrusting Habit',
        'Tongue-tie (Ankyloglossia) ',
        'Hearing Loss',
        'Mouth Breathing',
        'Early Childhood Caries',
        'Misaligned teeth and jaw (malocclusion)',
        'Velopharyngeal insufficiency',
      ],
    },
    {
      name: 'Speech Therapy Modalities',
      items: [
        'Dyslexia intervention ',
        'Augmentative and Alternative Communication',
        'Articulation therapy',
        'Modeling techniques',
        'Fluency therapy',
        'Feeding therapy',
        'Social skills exercises ',
        'Play-based intervention',
        'Language intervention therapy ',
        'Home exercise programs',
        'Dysphagia treatment and swallow studies ',
        'Parent education',
        'Motor planning for language acquisition ',
        'Environmental adaptations ',
      ],
    },
  ];

  return (
    <main id="speech-therapy" className="bg-[#F0EFEF]">
      <div className="w-full flex flex-col justify-between gap-4 sm:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
        <div>
          <h2 className="text-[38px] sm:text-[40px] md:text-[54px] text-primary font-bold">
            Speech Therapy
          </h2>
          <h4 className="text-[30px] sm:text-[34px] md:text-[40px] text-primary font-bold">
            Commonly Treated Diagnoses
          </h4>
        </div>
        <div className="flex flex-col md:flex-row items-start gap-4 sm:gap-10 xl:gap-28">
          <TitleAndDescription
            title="Articulation Disorder/ <br/> Phonological Disorder"
            description="Difficulty pronouncing sounds correctly, which results in speech that can be hard to understand. This can be a standalone diagnosis, or could occur secondary to diagnoses such as Down Syndrome. Treatment focuses on teaching accurate placement and production of sounds, generalizing correct productions to sentence and conversation levels, and home programming to increase carryover of skills outside the therapy environment."
          />
          <TitleAndDescription
            title="Dyslexia"
            description="A specific learning disability that impacts a person’s ability to recognize, spell, and decode written words accurately and fluently. It is linked to how the brain processes written and spoken language, and is not related to intelligence or vision. SLPs can assist individuals with dyslexia by targeting phonemic awareness (the ability to hear and manipulate sounds in words, and to know which letters represent those sounds), explicitly teaching spelling rules in a systematic order, and working to increase reading accuracy and fluency."
          />
        </div>
        <div className="flex flex-col md:flex-row items-start gap-4 sm:gap-10 xl:gap-28">
          <TitleAndDescription
            title="Receptive and Expressive Language Disorders"
            description="Difficulty understanding (receptive) or using (expressive) language. Treatment can target many aspects, such as asking/answering questions, describing, following directions, and using grammatically correct sentences, which can increase a child’s ability to independently participate in activities at home or school."
          />
          <div className="flex-1">
            <motion.div
              initial={{ opacity: 0, x: isMobile ? 0 : 300 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.9, ease: 'easeOut' }}
              viewport={{ once: true, amount: 0.5 }}
            >
              <img
                src={speechTable}
                alt="Speech therapy session for child in Wasilla, Alaska clinic"
                className="rounded-3xl w-full sm:w-[90%]"
              />
            </motion.div>
          </div>
        </div>
        <div>
          <motion.div
            initial={{ opacity: 0, x: isMobile ? -100 : -300 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.5 }}
          >
            <h2 className="text-[28px] md:text-[32px] text-primary font-semibold">
              ”...their speech therapist, is AMAZING!! My stepson has made leaps
              and bounds with reading and speech. He is no longer two grade
              levels behind. We appreciate Guidepost...”
            </h2>
          </motion.div>
        </div>

        <ModalitiesSection services={servicesData} />

        <motion.div
          initial={{ opacity: 0, x: -200 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1.3, ease: 'easeInOut', delay: 0.3 }}
          viewport={{ once: true, amount: 0.3 }}
          className="flex items-center justify-center gap-4 sm:gap-10 flex-col md:flex-row mt-4"
        >
          <GradientOutlineButton
            text="Learn More About Speech Therapy"
            navigateTo={'/services/speech-therapy'}
            width="w-full sm:w-[320px]"
          />
          <a href="tel:+19073764880" className="w-full sm:w-[320px]">
            <GradientButton
              text="Call to Schedule an Appointment"
              width="w-full sm:w-[320px]"
            />
          </a>
        </motion.div>
      </div>
    </main>
  );
};

export default SpeechTherapy;
